import React, { useState, useEffect } from "react";
import { Center, Button, Group, Paper, Stack, Text, Textarea } from "@mantine/core";
import HardwareTicketDataService from '../services/hardware-ticket-activities';

import survey_secret from '../satisfaction-survey-secret';

function TicketSurvey(props) {
    const [numberSelected, setNumberSelected] = useState(0);
    const [writtenInput, setWrittenInput] = useState("");
    const [showThankYou, setShowThankYou] = useState(false);
    const [keepAnonymous, setKeepAnonymous] = useState(0);
    const [showError, setShowError] = useState(false);

    async function submitSurvey() {
        let data = {
            numberSelected: numberSelected,
            writtenInput: writtenInput,
            ticketId: parseInt(props.match.params.id),
            keepAnonymous: keepAnonymous,
            surveySecret: survey_secret
        };

        //console.log("Data to submit to backend: ", data);

        try {
            let response = await HardwareTicketDataService.submitSatisfactionSurvey(data);

            console.log("Response from backend: ", response);

            if(response && response.status === 200) {
                setShowError(false);
                setShowThankYou(true);
            }

            else {
                setShowError(true);
            }
        }

        catch {
            setShowError(true);
        }
 
    }


    return (
        <>
            <Center style={{ minHeight: "100vh" }}>
                {showThankYou === false ?
                    <Stack align="center">
                        <Text fw={700} size="xl">Ticket Satisfaction Survey</Text>
                        <Paper withBorder radius="md" p="md">
                            <Center>
                                <Text>{"On a scale of 1-10, how would you rate your satisfaction with the service you received on this ticket?"}</Text>
                            </Center>
                            <Center>
                                <Text style={{marginBottom: "50px"}}>{"1 = Very Unsatisfied, 10 = Very Satisfied"}</Text>
                            </Center>
                            <Center>
                                <Group spacing="sm">
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const num = i + 1;
                                        const selected = numberSelected === num;

                                        return (
                                        <Paper
                                            key={num}
                                            withBorder
                                            radius="md"
                                            p="md"
                                            onClick={() => setNumberSelected(num)}
                                            style={{
                                            cursor: "pointer",
                                            backgroundColor: selected
                                                ? "var(--mantine-color-blue-light)"
                                                : undefined,
                                            borderColor: selected
                                                ? "var(--mantine-color-blue-6)"
                                                : undefined,
                                            }}
                                        >
                                            <Text fw={600} ta="center">
                                                {num}
                                            </Text>
                                        </Paper>
                                        );
                                    })}
                                </Group>
                            </Center>
                            <Center style={{marginTop: "50px"}}>
                                <Text style={{marginBottom: "20px"}}>{"Do you have any additional comments?"}</Text>
                            </Center>
                            <Center>
                                <Textarea 
                                    placeholder="Input text here"
                                    w="100%"
                                    onChange={(e) => setWrittenInput(e.target.value)}
                                />
                            </Center>
                            
                        </Paper>
                        <Center style={{marginTop: "50px", marginBottom: "20px"}}>
                                <Button onClick={() => submitSurvey()}>Submit</Button>
                        </Center>
                        {showError && 
                            <Center>
                                <Text c="red">There was an error submitting your response.</Text>
                            </Center>
                        }
                    </Stack>
                    :
                    <Text>Thank you, your response has been submitted.</Text>
                }
            </Center>
        </>
    );
}

export default TicketSurvey;